import { createPortal } from 'react-dom';

/**
 * Renders children into document.body so full-screen `position:fixed` overlays
 * span the entire viewport (not clipped or offset by Layout / main / transform ancestors).
 */
export default function ModalPortal({ children }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
